/**
 * @author: leroy
 * @date: 2021/8/23 16:11
 * @description：common
 */
import Url from '@/utils/url';
import api from '@/utils/api';

// 获取sts token
export async function getSTSToken() {
  return api<API.Response<API.Common.STS>>(Url.sts, {
    method: 'GET',
  });
}

// 获取服务器时间
export async function getServerTime() {
  return api<API.Response<{ date: string; timestamp: number }>>(Url.serverTime, {
    method: 'GET',
  });
}

// 获取服务器时间
export async function postFeedback(data: API.Common.Feedback) {
  return api<API.Response>(Url.feedback, {
    method: 'POST',
    data,
  });
}

//获取小程序链接
export async function getMiniAppUrl(params: { id: string; anid?: string }) {
  return api<API.Response<{ link: string }>>('/exam/wx-url-link', {
    method: 'GET',
    params,
  });
}

//获取socket负载均衡
export async function getSocketBlance() {
  return api<API.Response<{ socket: string }>>('/socket/blance', {
    method: 'GET',
  });
}
